import Content from "../../template/content";
import {useState, useEffect} from 'react';
import DestaquesGrid from "../../components/destaquesGrid";
import Blob from "../../components/blob";
import PortfolioButton from "../../components/portfolioButton";
import { getDestaques } from "../../data/About";
import { useNavigate } from "react-router";
const Home = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState(['']);

    const handlePBClick = () => {
        navigate('/portfolio');
    }

    useEffect(() => {
        const get = async () => {
            const result = await getDestaques();
            if(result){
                console.log(result);
                setList(result);
            } else {
                console.log('sem dados');
            }
        }
        get();
        setLoading(false);
    }, []);

    return(
        <Content>
            <div className="text-center h1 my-2 my-lg-4">Destaques</div>
            <hr/>
            <div className="my-5">
                <DestaquesGrid goto={handlePBClick} list={list} loading={loading}/>
            </div>
            <div className="d-flex justify-content-center">
                <PortfolioButton onclick={handlePBClick}/>
            </div>
            <div className="text-center h1 my2 my-lg-4">Sobre</div>
            <hr/>
            <div className="mt-5 mb-md-4 d-flex flex-wrap">
                <div className="col-12 col-md-5 col-lg-3 d-flex justify-content-center">
                    <Blob/>
                </div>
                <div className="col-12 col-md-7 col-lg-9 py-4 px-4 px-xxl-0 about">
                    <p className="mb-3 me-xxl-5">Olá! Meu nome é Victor, comecei na tattoo em 2020. Desde criança sempre gostei muito de desenhar a lápis,
                    gosto de criar artes exclusivas para tornar as tattoos dos meus clientes algo especial e marcante.
                    </p>
                    <p className="mb-3 me-xxl-5">Atualmente trabalho apenas com tatuagens em preto e branco, nos estilos Old School, Sketch e Realismo. Gostou de alguma arte que viu aqui na home? Clique em <b>Veja mais</b> ou <b>Portfólio</b> e confira todos meus trabalhos com descrição detalhada.
                    </p>
                </div>
            </div>
            <div className="d-flex pt-4">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3730.460463204396!2d-51.6903635781625!3d-20.77265136494735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94909886974bb813%3A0xab0e84ab91678204!2sR.%20Duque%20de%20Caxias%2C%202796%20-%20Centro%2C%20Tr%C3%AAs%20Lagoas%20-%20MS%2C%2079645-310!5e0!3m2!1spt-PT!2sbr!4v1664221976641!5m2!1spt-PT!2sbr" width="auto" height="450" style={{border:0, width:'100%', marginBottom: '-1.4rem', marginTop: '1rem'}} loading="lazy" ></iframe>
            </div>
        </Content>
    )
}

export default Home;